function getPrefix() {
  const lang = document.documentElement.getAttribute("lang") || "it";
  return lang === "it" ? "" : `/${lang}`;
}

const PREFIX = getPrefix();

const TRANSLATIONS = {
  it: { loading: "Caricamento pagina...", error: "Errore caricamento pagina.", close: "Chiudi" },
  en: { loading: "Loading page...", error: "Error loading page.", close: "Close" },
  fr: { loading: "Chargement de la page...", error: "Erreur de chargement.", close: "Fermer" },
  de: { loading: "Seite wird geladen...", error: "Fehler beim Laden der Seite.", close: "Schließen" },
  es: { loading: "Cargando página...", error: "Error al cargar la página.", close: "Cerrar" }
};

const T = TRANSLATIONS[document.documentElement.getAttribute("lang")] || TRANSLATIONS.it;

const _pageHtmlCache = new Map();
const _pageTitleCache = new Map();

function extractTitleFromHTML(html) {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return (
    temp.querySelector(".page-title")?.innerText ||
    temp.querySelector(".shopify-policy__title")?.innerText ||
    temp.querySelector("h1")?.innerText ||
    "Titolo"
  );
}

function fetchPageHtmlCached(page) {
  if (_pageHtmlCache.has(page)) return Promise.resolve(_pageHtmlCache.get(page));
  return fetch(`${window.location.origin}${PREFIX}/pages/${page}`)
    .then(r => r.text())
    .then(html => {
      _pageHtmlCache.set(page, html);
      return html;
    });
}

function fetchPageTitle(page, callback) {
  if (_pageTitleCache.has(page)) {
    callback(_pageTitleCache.get(page));
    return;
  }
  fetchPageHtmlCached(page)
    .then(html => {
      const title = extractTitleFromHTML(html);
      _pageTitleCache.set(page, title);
      callback(title);
    })
    .catch(() => {
      const fallback = "Titolo non disponibile";
      _pageTitleCache.set(page, fallback);
      callback(fallback);
    });
}

function ensurePopupStyleTag() {
  let style = document.getElementById("popupDynamicBoxStyles");
  if (style) return style;
  style = document.createElement("style");
  style.id = "popupDynamicBoxStyles";
  style.innerHTML = `
#popupDynamicBox::-webkit-scrollbar { display: none; }
.popup-dynamic-box { scrollbar-width: none; -ms-overflow-style: none; }
body.popup-dynamic-open { overflow: hidden; touch-action: none; }
`;
  document.head.appendChild(style);
  return style;
}

function resolveTarget(cfg) {
  // cfg._host può essere un Element o una stringa selettore
  if (cfg._host instanceof Element) {
    // se è un elemento di configurazione ma è stato passato anche cfg.target, preferiamo il selettore
    if (cfg.target) {
      const sel = document.querySelector(cfg.target);
      if (sel) return sel;
    }
    return cfg._host;
  }
  if (typeof cfg._host === "string" && cfg._host.trim()) {
    const el = document.querySelector(cfg._host);
    if (el) return el;
  }
  if (cfg.target) {
    const el = document.querySelector(cfg.target);
    if (el) return el;
  }
  return null;
}

function sanitizeTextWeight(value) {
  if (!value && value !== 0) return null;
  const v = String(value).trim();
  if (!v) return null;
  // accetta numeri 100-900 o parole chiave comuni
  if (/^(normal|bold|bolder|lighter|inherit|initial|unset)$/i.test(v)) return v;
  if (/^[1-9]00$/.test(v) && Number(v) >= 100 && Number(v) <= 900) return v;
  return null;
}

function createPopupButton(cfg) {
  if (!cfg || !cfg.page) return null;

  const target = resolveTarget(cfg);
  if (!target) return null;

  const btn = document.createElement("button");
  btn.type = "button";

  Object.assign(btn.style, {
    padding: "10px 0",
    borderRadius: cfg.radius || "5px",
    marginBottom: "20px",
    width: "100%",
    textAlign: "left",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    paddingLeft: "10px",
    transition: "background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease",
    border: `${cfg.borderwidth || "1px"} ${cfg.borderstyle || "solid"} ${cfg.bordercolor || "#dddddd"}`
  });
  btn.style.setProperty("background-color", cfg.bgcolor || "#ffffff", "important");
  btn.style.setProperty("color", cfg.textcolor || "#2c2c2c", "important");

  // textweight: preferiamo valore valido, altrimenti fallback "500"
  const parsedWeight = sanitizeTextWeight(cfg.textweight);
  const textWeight = parsedWeight || "500";

  const iconHTML = cfg.icon
    ? cfg.icon.includes('at ')
      ? `<i class="${cfg.icon}" style="font-size:20px;line-height:1;"></i>`
      : `<img src="${cfg.icon}" alt="" class="popup-btn-icon" style="width:20px;height:20px;">`
    : "";
  // Applichiamo font-weight solo se abbiamo un valore valido
  const weightStyle = parsedWeight ? `font-weight:${textWeight};` : `font-weight:${textWeight};`;
  btn.innerHTML = `${iconHTML}<span class="popup-btn-label" style="${weightStyle} margin-left:${cfg.icon ? "10px" : "0"};"></span>`;

  btn.addEventListener("mouseover", () => {
    btn.style.setProperty("background-color", cfg.bgcolorHover || "#F5F3EF", "important");
    btn.style.setProperty("color", cfg.textcolorHover || cfg.textcolor || "#2c2c2c", "important");
  });
  btn.addEventListener("mouseout", () => {
    btn.style.setProperty("background-color", cfg.bgcolor || "#ffffff", "important");
    btn.style.setProperty("color", cfg.textcolor || "#2c2c2c", "important");
  });

  if (cfg.position === "before") {
    target.insertBefore(btn, target.firstChild);
  } else {
    target.appendChild(btn);
  }

  btn.addEventListener("click", () => openPopup(cfg.page, btn));

  fetchPageTitle(cfg.page, titolo => {
    const labelSpan = btn.querySelector(".popup-btn-label");
    if (labelSpan) labelSpan.textContent = titolo;
    const icon = btn.querySelector(".popup-btn-icon");
    if (icon) icon.alt = titolo;
    // riaffermiamo il peso (utile se il browser reflowa)
    if (labelSpan) labelSpan.style.fontWeight = textWeight;
  });

  return btn;
}

function openPopup(page, btnElement) {
  if (document.getElementById("popupDynamicBox")) return;
  ensurePopupStyleTag();
  const box = document.createElement("div");
  box.id = "popupDynamicBox";
  box.className = "popup-dynamic-box";
  Object.assign(box.style, {
    position: "fixed",
    top: "0",
    right: "0",
    width: "480px",
    maxWidth: "100%",
    height: "100vh",
    backgroundColor: "#fff",
    zIndex: "99999999",
    overflowY: "scroll",
    padding: "20px",
    boxShadow: "-2px 0 12px rgba(0,0,0,0.3)",
    boxSizing: "border-box"
  });
  box.setAttribute("role", "dialog");
  box.setAttribute("aria-modal", "true");
  box.setAttribute("tabindex", "-1");
  box.setAttribute("aria-label", T.loading);

  const titolo = document.createElement("h2");
  Object.assign(titolo.style, {
    marginTop: "40px",
    marginBottom: "20px",
    fontSize: "22px",
    fontWeight: "600",
    borderBottom: "1px solid #ccc",
    paddingBottom: "10px",
    color: "#2c2c2c"
  });
  titolo.textContent = "";

  const chiudi = document.createElement("button");
  chiudi.textContent = "✖";
  Object.assign(chiudi.style, {
    color: "#2C2C2C",
    background: "none",
    border: "none",
    cursor: "pointer",
    position: "absolute",
    top: "15px",
    right: "20px",
    lineHeight: "1",
    padding: "0",
    fontSize: "16px",
    fontWeight: "bold"
  });
  chiudi.setAttribute("aria-label", T.close);

  const contenuto = document.createElement("div");
  contenuto.innerHTML = `<p>${T.loading}</p>`;

  box.appendChild(chiudi);
  box.appendChild(titolo);
  box.appendChild(contenuto);
  document.body.appendChild(box);
  document.body.classList.add("popup-dynamic-open");

  const previouslyFocused = document.activeElement;
  chiudi.focus();

  const focusableSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';
  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(focusableSelector)).filter(el => el.offsetParent !== null);
  }

  function onKeyDown(e) {
    if (e.key === "Escape") {
      e.preventDefault();
      closePopup();
      return;
    }
    if (e.key === "Tab") {
      const focusable = getFocusableElements(box);
      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function closePopup() {
    document.removeEventListener("keydown", onKeyDown);
    chiudi.removeEventListener("click", closePopup);
    if (document.body.contains(box)) document.body.removeChild(box);
    const style = document.getElementById("popupDynamicBoxStyles");
    if (style) style.parentNode.removeChild(style);
    document.body.classList.remove("popup-dynamic-open");
    try { previouslyFocused?.focus(); } catch (e) {}
  }

  document.addEventListener("keydown", onKeyDown);
  chiudi.addEventListener("click", closePopup);

  fetchPageHtmlCached(page)
    .then(html => {
      const titoloPagina = extractTitleFromHTML(html);
      titolo.textContent = titoloPagina;
      const labelSpan = btnElement.querySelector(".popup-btn-label");
      if (labelSpan) labelSpan.textContent = titoloPagina;
      const icon = btnElement.querySelector(".popup-btn-icon");
      if (icon) icon.alt = titoloPagina;
      const temp = document.createElement("div");
      temp.innerHTML = html;
      const main =
        temp.querySelector(".rte") ||
        temp.querySelector(".page-content") ||
        temp.querySelector(".shopify-policy__body") ||
        temp.querySelector("main") ||
        temp;
      contenuto.innerHTML = main.innerHTML;
      box.setAttribute("aria-label", titoloPagina);
    })
    .catch(() => {
      contenuto.innerHTML = `<p>${T.error}</p>`;
    });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-popup-config]").forEach(el => {
    const cfg = {
      page: el.dataset.page,
      icon: el.dataset.icon || "",
      target: el.dataset.target || "",
      position: el.dataset.position || "after",
      bgcolor: el.dataset.bgcolor || "",
      bgcolorHover: el.dataset.bgcolorHover || "",
      radius: el.dataset.radius || "",
      textcolor: el.dataset.textcolor || "",
      textcolorHover: el.dataset.textcolorHover || "",
      bordercolor: el.dataset.bordercolor || "",
      borderwidth: el.dataset.borderwidth || "",
      borderstyle: el.dataset.borderstyle || "",
      // nuovo parametro per il peso del testo (può essere "700" o "bold" ecc.)
      textweight: el.dataset.textweight || ""
    };

    // Passiamo l'elemento host (campo HTML/Liquid) come _host
    cfg._host = el;

    createPopupButton(cfg);
  });
});
